<template>
  <NuxtLink
    class="partnership-agency"
    :to="localePath({
      name: 'agency-partners-slug',
      params: {
        slug: props.partner.slug,
      },
    })"
  >
    <div class="head">
      <UiComponentImage
        v-if="props.partner.logo"
        :alt="props.partner.logo.alt"
        class="logo"
        :expected-size="181"
        :extra-params="{
          fit: 'crop',
          h: 127,
          w: 181,
        }"
        :height="props.partner.logo.height"
        :source="props.partner.logo.url"
        :width="props.partner.logo.width"
      />
    </div>
    <div class="body">
      <UiComponentHeading :level="2">
        {{ props.partner.name }}
      </UiComponentHeading>
      <UiComponentParagraph>{{ props.partner.description }}</UiComponentParagraph>
      <UiComponentParagraph v-if="haveLanguages">
        <slot />
        {{ props.partner.languages }}
      </UiComponentParagraph>
      <div class="tags">
        <UiComponentTag
          size="s"
          type="secondary"
        >
          {{ props.partner.program.title }}
        </UiComponentTag>
      </div>
    </div>
  </NuxtLink>
</template>

<script setup>
// Props
const props = defineProps({
  partner: {
    required: true,
    type: Object,
  },
})

// Computed Properties
const haveLanguages = computed(() => {
  return !!props.partner.languages
})
</script>

<style lang="postcss" scoped>
.partnership-agency {
  @apply flex flex-col w-full p-4 pb-8 bg-white border-2 border-grey-blue-200 rounded-4xl transition-all duration-500 ease-out;

  &:hover {
    @apply shadow-light4;
  }

  .head {
    @apply flex justify-center w-full py-4 bg-white border border-grey-blue-200 rounded-[18px];

    .logo {
      @apply rounded-none;
    }
  }

  .body {
    @apply flex flex-col mt-4 px-2;

    .h2 {
      @apply font-medium text-2xl leading-8;

      @screen mdminus {
        @apply text-[28px] leading-[34px];
      }

      @screen mdplus {
        @apply text-3xl leading-10;
      }
    }

    p {
      @apply mt-2 text-grey-blue-600 leading-7;

      & + p {
        @apply text-sm leading-6;
      }
    }

    .tags {
      @apply flex mt-4;
    }
  }
}
</style>
